
<ng-container *ngIf="entity">

    <ng-container *ngIf="entity.picturePublicUrl">
        <app-summary-field [label]="label" *ngIf="label">
            <app-user-avatar [user]="entity" ></app-user-avatar>
        </app-summary-field>
        <app-user-avatar [user]="entity" *ngIf="!label"></app-user-avatar>
    </ng-container>

    <app-summary-field [label]="label" *ngIf="!entity.picturePublicUrl" iconName="user">
        {{entity.name}}
    </app-summary-field>
</ng-container>